// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2DStl","item":"PaymentsMobile_item__LEbOe","label":"PaymentsMobile_label__2oPyf","amount":"PaymentsMobile_amount__m5ysj"};